import React, { useEffect, useState } from "react";
import { DropdownButton, Dropdown, Table, Row, Col, Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'
import '../../assets/css/Player/CorporateStandings.css';
import Batminton from './../icons/Batminton';
import TableTennis from './../icons/TableTennisIcon';
import Bowling from './..//icons/Bowling';
import RunIcon from './..//icons/RunIcon';
import notFound from '../../assets/images/avatars/notfound1.png'
import cardBg from '../../assets/images/complete-match-bg.png'
import Loader from '../../../src/views/admin/Common/Loader';
import main_logo from '../../assets/images/UPG_site_logo.png';

import { CCard, CCardBody, CCol, CRow } from '@coreui/react'

import axios from 'axios';
import { GetTournamentList } from '../../API/admin'
import { FetchCorporats, FetchAllPoints } from '../../API/player';


import {
  CFormSelect

} from '@coreui/react';

const CorporateStandings = ({ onValueChange, gameType, TournamentName, TournamentID, corporate, CorporateList, waitListGame, enrolledSport }) => {
  console.log("CorporateList", CorporateList);
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE

  const [Tournaments, setTournaments] = useState([]);
  const [SelectedTournament, setSelectedTournament] = useState('');
  const [loaderStatus, setloaderStatus] = useState(true);
  const [CorporateListData, setCorporateListData] = useState(false);
  const [data, setData] = useState([]);
  const [Flag, setFlag] = useState(false);


  const location = useLocation();

  // useEffect(() => {
  //   let callAPI2 = async () => {
  //     if ( ! TournamentID == '') {
  //       let FormData = {
  //           "tournament_id": TournamentID
  //       }
  //       let res = await FetchAllPoints(FormData);

  //       if (res.status) {
  //         setloaderStatus(false)
  //         const CorporateListData = Object.keys(res.data).map(key => ({
  //           name: key,
  //           badminton: res.data[key].badminton,
  //           table_tennis: res.data[key].table_tenis,
  //           total: res.data[key].total
  //       }));
  //         setCorporateList(CorporateListData)
  //       }

  //     }
  //   }
  //   callAPI2()
  // }, [TournamentID]);

  // useEffect(() => {
  //   // Populate CorporateList once data is fetched
  //   const newCorporateList = data.map(item => ({
  //     name: item.name,
  //     badminton: 0,
  //     table_tennis: 0,
  //     total: 0
  //   }));
  //   setCorporateList(newCorporateList);
  // }, [data]);
  const selectStyle = {
    width: '156px',        // Default width
    maxWidth: '100%',      // Maximum width
    overflow: 'hidden',    // Hide overflow content
    textOverflow: 'ellipsis', // Show ellipsis for overflow
    whiteSpace: 'nowrap'   // Prevent text wrapping
  };
  // useEffect(() =>{
  // if(CorporateList.length) {
  //   setCorporateListData(true); 
  // }
  // },[onValueChange])

  useEffect(() => {
    if (CorporateList.length) {
      setCorporateListData(true);
    }
  }, [CorporateList])



  useEffect(() => {
    setFlag(!Flag);
  }, [SelectedTournament])
  useEffect(() => {

    const callAPI = async () => {
      setloaderStatus(true);
      let res = await GetTournamentList(); // Make sure this function is defined
      if (res.status) {

        console.log(res.status);
        setTournaments(res.data);
        setloaderStatus(false);

      } else {
        setloaderStatus(false);

      }
    };
    callAPI();


  }, [location.search]);

  useEffect(() => {
    if (Tournaments.length > 0) {
      const firstTournamentId = Tournaments[0]._id;
      setSelectedTournament(firstTournamentId);
      onValueChange(firstTournamentId);
      gameType(getGame());
      TournamentName(Tournaments[0].name)
      // setloaderStatus(false)
    }
  }, [Tournaments]);

  const handleChange = (event) => {
    console.log(event.target);
    const selectedId = event.target.value;
    setSelectedTournament(selectedId);
    onValueChange(selectedId);
    gameType(getGame());
    TournamentName(event.target.options[event.target.selectedIndex].text)
    // setloaderStatus(true)
  };

  const getGame = () => {
    const searchParams = new URLSearchParams(location.search);
    let game = searchParams.get('game');
    if (!game) {
      game = 'Badminton';
    }
    return game;
  };
  function extractdomain(inputString, startChar, endChar) {
    const startIndex = inputString.indexOf(startChar);
    let j = -1;
    for (let i = startIndex + 1; i < inputString.length; i++) {
      if (inputString[i] == '.') {
        j = i;
        break;

      }

    }
    let domain = inputString.substring(startIndex + 1, j)
    console.log(domain)
    return domain;
  }
  if (corporate != null) {


    let playerCorporate = extractdomain(corporate.corporate_email, '@', '.')
    console.log("player " + playerCorporate)
  }

  return (
    <>
      {loaderStatus ? <Loader /> : null}

      {


        waitListGame.badminton == true && getGame() == 'Badminton' ? (
          null
        ) : waitListGame.table_tenis == true && getGame() == 'TableTennis' ? (
          null

        ) : waitListGame.bowling == true && getGame() == 'bowling' ? (
          null

        ) : waitListGame.twok_run == true && getGame() == '2k_run' ? (
          null

        ) : enrolledSport.badminton == false && getGame() == 'Badminton' ? (
          null
        ) : enrolledSport.table_tenis == false && getGame() == 'TableTennis' ? (
          null

        ) : enrolledSport.bowling == false && getGame() == 'bowling' ? (
          null

        ) : enrolledSport.twok_run == false && getGame() == '2k_run' ? (
          null) :

          SelectedTournament != '' ? (

            <div className='corporate_standings'>
              <Row className="mb-5">
                <Row className="text-dark align-items-xs-center mt-4 mb-4">
                  <Col md={6} className="text-start col-group text-white new_all_common_heading" id="corporateStandings">
                    Team Standings
                  </Col>
                  <Col md={6} className="text-end col-group">
                    <div className="d-flex justify-content-end align-items-center" style={{ whiteSpace: 'nowrap' }}>
                      <CFormSelect
                        aria-label="Default select example"
                        onChange={handleChange}
                        className="bg-dark text-white"
                        value={SelectedTournament}
                        style={selectStyle}
                      >
                        {Tournaments.length > 0 ?
                          Tournaments.map((Tournament, index) => (
                            <option key={index} name={Tournament.name} value={Tournament._id}>{Tournament.name}</option>
                          ))
                          : null}
                      </CFormSelect>
                    </div>
                  </Col>
                </Row>
                <Col>
                  <Card className="border-radius25px overflow-auto complete-nav-card border-0">
                  <Card.Body className="p-0">
  {CorporateList.length > 0 ? (
    <Table bordered className="text-center mb-0">
      <thead className="border-0">
        <tr className="border-0">
          <th className="border-0 text-size table-th">Team</th>
          <th className="border-0 text-size table-th">
            <Batminton /> <span className="text_hiderespons">Badminton</span>
          </th>
          <th className="border-0 text-size table-th">
            <TableTennis /><span className="text_hiderespons"> Table Tennis</span>
          </th>
          {/* <th className="border-0 text-size table-th">
            <Bowling /> <span className="text_hiderespons"> Bowling </span>
          </th>
          <th className="border-0 text-size table-th">
            <RunIcon /> <span className="text_hiderespons"> 2k Run</span>
          </th> */}
          <th className="border-0 text-size table-th">Total</th>
        </tr>
      </thead>
      <tbody>
          {CorporateList.sort((a, b) => b.total - a.total).map((item, index) => {
            console.log("item" ,item)
            const isHighlighted = corporate.corporate_email?.trim().toLowerCase() === item.name?.trim().toLowerCase();
            return (
              <tr 
                key={index} 
                // style={{ color: isHighlighted ? 'red' : null }}
              >
                <td className="standing_tbl_td d-flex align-items-center" style={{ minWidth: "155px" }}>
                  <img
                    src=  {IMAGE_URL + 'teams/' + item.logo}
                    alt="img"
                    className="standing_tble_icon"
                  />
                  <span className="standing_tbl_icon_txt" style={{ color: isHighlighted ? '#C50E3C' : null, fontWeight: 400}}>{item.name}</span>
                </td>
                <td style={{ verticalAlign: "middle", color: isHighlighted ? 'red' : null }}>{item.badminton}</td>
                <td style={{ verticalAlign: "middle" , color: isHighlighted ? 'red' : null}}>{item.table_tennis}</td>
                {/* <td style={{ verticalAlign: "middle" , color: isHighlighted ? 'red' : null}}>{item.bowling}</td> */}
                {/* <td style={{ verticalAlign: "middle", color: isHighlighted ? 'red' : null}}>{item.twokrun}</td> */}
                <td style={{ verticalAlign: "middle", color: isHighlighted ? 'red' : null }}>{item.total}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  ) : (
    <CCard
      style={{
        position: 'relative',
        background: '#131313',
        borderRadius: '15px',
      }}
    >
      <div
        className="card-background"
        style={{ backgroundImage: `url(${cardBg})` }}
      />
      <CCardBody
        className="d-flex justify-content-center align-items-center"
        style={{ padding: '0px', color: '#fff', height: '200px' }}
      >
        <div className="no_data_img_main">
          <span
            style={{
              color: 'white',
              fontSize: '20px',
              fontWeight: '700',
            }}
          >
            No Team Standings found
          </span>
        </div>
      </CCardBody>
    </CCard>
  )}
</Card.Body>

                  </Card>
                </Col>
              </Row>
            </div>
          )
            : null
      }
    </>
  );
}

export default CorporateStandings;


